"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var clsx_1 = tslib_1.__importDefault(require("clsx"));
var react_1 = tslib_1.__importStar(require("react"));
var react_quill_1 = tslib_1.__importDefault(require("react-quill"));
require("react-quill/dist/quill.snow.css");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var DEFAULT_MODULES = {
    toolbar: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [
            { list: 'ordered' },
            { list: 'bullet' },
            { indent: '-1' },
            { indent: '+1' },
        ],
        ['link'],
        ['clean'],
    ],
    clipboard: {
        matchVisual: false,
    },
};
var DEFAULT_FORMATS = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
];
var RichTextEditor = function (_a) {
    var _b = _a.value, value = _b === void 0 ? '' : _b, onChange = _a.onChange, children = _a.children, id = _a.id, className = _a.className, hideBorder = _a.hideBorder, hideToolbar = _a.hideToolbar, rest = tslib_1.__rest(_a, ["value", "onChange", "children", "id", "className", "hideBorder", "hideToolbar"]);
    var handleChange = react_1.useCallback(function (content) {
        if (content === void 0) { content = ''; }
        onChange(content);
    }, [onChange]);
    return (react_1.default.createElement(StyledContainer, { id: id, className: clsx_1.default(className, {
            'hide-border': hideBorder,
            'hide-toolbar': hideToolbar,
        }) },
        react_1.default.createElement(react_quill_1.default, tslib_1.__assign({}, rest, { theme: "snow", value: value, onChange: handleChange, modules: DEFAULT_MODULES, formats: DEFAULT_FORMATS }))));
};
RichTextEditor.displayName = 'FOS_RichTextEditor';
exports.default = RichTextEditor;
var StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  & > .quill > .ql-toolbar {\n    background: ", ";\n  }\n\n  && > .quill > .ql-container * {\n    font-family: ", ";\n  }\n\n  && > .quill > .ql-container *:not(a) {\n    color: ", ";\n  }\n\n  &&.hide-toolbar > .quill > .ql-toolbar {\n    display: none;\n  }\n\n  &&.hide-border > .quill > .ql-container {\n    border: none;\n  }\n"], ["\n  & > .quill > .ql-toolbar {\n    background: ", ";\n  }\n\n  && > .quill > .ql-container * {\n    font-family: ", ";\n  }\n\n  && > .quill > .ql-container *:not(a) {\n    color: ", ";\n  }\n\n  &&.hide-toolbar > .quill > .ql-toolbar {\n    display: none;\n  }\n\n  &&.hide-border > .quill > .ql-container {\n    border: none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[50];
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoRegular;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[900];
});
var templateObject_1;
